var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "59px",
    height: "59px",
    viewBox: "0 0 59 59",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(4.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FFF",
    strokeWidth: 7,
    cx: 25.5,
    cy: 25.5,
    r: 25.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF",
    x: 22,
    y: 22,
    width: 7,
    height: 20,
    rx: 3.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFF",
    x: 22,
    y: 10,
    width: 7,
    height: 7,
    rx: 3.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWhite);
export default __webpack_public_path__ + "static/media/info-white.eb15bfc42a586ed1c99099ed45be5229.svg";
export { ForwardRef as ReactComponent };